module.exports = __webpack_public_path__ + "6e1643a0a944bd601a46002bc295e70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/gears4/forge.png
// module id = 1055
// module chunks = 0